import {BeforeSpinStopPresentationController} from "@nolimitcity/slot-game/bin/core/beforespinstoppresentation/BeforeSpinStopPresentationController";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Elastic, TimelineLite} from "gsap";
import {ThorGameMode} from "../gamemode/ThorGameMode";
import {ThorGameShaker} from "../gameshake/ThorGameShaker";
import {ThorRespinNudgeReelController} from "../reel/nudgereel/ThorRespinNudgeReelController";
import {ThorParsedGameData} from "../server/data/ThorParsedGameData";
import {ThorGameConfig} from "../ThorGameConfig";
import {ThorSoundConfig} from "../ThorSoundConfig";

/**
 * Created by Jerker Nord on 2019-04-08.
 */

export class ThorBonusFeatureController extends BeforeSpinStopPresentationController {

    private _nudgeFeatureRewarded:string;
    private _topSym:string;

    constructor(index:number) {
        super(index, "ThorBonusFeatureController");
    }

    protected parseFeatureTriggered(data:ThorParsedGameData):boolean {
        this._nudgeFeatureRewarded = data.nudgeFeatureRewarded;
        this._topSym = data.reels[4][3];
        if(this._topSym == "B") {
            this._topSym = data.reels[4][2];
        }
        if((data.mode == ThorGameMode.NUDGE_RESPIN && (data.nextMode == ThorGameMode.NUDGE_RESPIN || data.nextMode == ThorGameMode.NORMAL))) {
            return true;
        }
        return false;
    }

    protected getSpinStopDelay(data:ThorParsedGameData):number {
        return GameSetting.isFastSpin ? 1 : 1.5;
    }

    private replaceSymbol():void {
        Reels.getSymbol(4, -1)!.replaceWith(this._topSym, 4);
    }

    protected startPresentation(timeline:TimelineLite):void {
        timeline.add([
            () => Reels.getSymbol(4, 0)!.changeState({
                state : ThorGameConfig.instance.SYMBOL_STATES.normal,
                fadeInDuration : 0.3
            }),
            () => Reels.getSymbol(4, 1)!.changeState({
                state : ThorGameConfig.instance.SYMBOL_STATES.normal,
                fadeInDuration : 0.3
            }),
            () => Reels.getSymbol(4, 2)!.changeState({
                state : ThorGameConfig.instance.SYMBOL_STATES.normal,
                fadeInDuration : 0.3
            })
        ]);
        timeline.add(() => this.replaceSymbol());
        timeline.add(() => (<ThorRespinNudgeReelController>Reels.getReel(4)).nudge(1, 1, Elastic.easeIn.config(1, 1), 0));
        timeline.add(() => SlotGame.sound.playEffect(ThorSoundConfig.instance.BONUS_NUDGE));
        timeline.add(() => EventHandler.dispatchEvent(new GameEvent(ThorGameShaker.START_GAME_SHAKING_REEL_AREA)), "+=1.1");
        timeline.add(() => EventHandler.dispatchEvent(new GameEvent(ThorGameShaker.STOP_GAME_SHAKING)), "+=0.4");
    }

    protected stopPresentation(isAborted:boolean):void {
        if(isAborted == true) {
            (<ThorRespinNudgeReelController>Reels.getReel(4)).abortNudge();
        }
    }

    protected resetFeature() {
        //TODO: Do reset?
    }
}